import { Injectable } from '@angular/core';
import { SlackService } from './slack.service';
import { WebHookService } from './web-hook.service';

@Injectable({
  providedIn: 'root'
})
export class LoggingService {

	constructor(private slackService: SlackService, private webHookService: WebHookService) { }
    logError(message: string, stack: string) {
      //console.log('LoggingService: ' + message);
	  //this.webHookService.postError(message,stack); 
	  //this.slackService.postErrorOnSlack(message,stack);
	  
    }
}
